// extracted by mini-css-extract-plugin
module.exports = {"root":"ShadowImage_root__4brZA","shadow":"ShadowImage_shadow__90Nqe","img":"ShadowImage_img__KIiFC"};